<template>
  <div>
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      style="margin-bottom:40px"
    >
      <el-breadcrumb-item :to="{ path: '/userTab' }"
        >企业信息</el-breadcrumb-item
      >
      <el-breadcrumb-item>认证详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="el-card">
      <div class="xingxi">
        <div class="tiao"></div>
        <i v-if="this.dataId == 1">企业合作认证（审核中）</i>
        <i v-if="this.dataId == 2 || this.dataId == 4"
          >数据采集合作伙伴认证（审核中）</i
        >
        <i v-if="this.dataId == 3">数据处理合作伙伴认证（审核中）</i>
      </div>

      <div class="biaodan">
        <el-form
          label-position="top"
          label-width="80px"
          :model="userForm"
          ref="userForm"
          :rules="userRules"
        >
          <el-form-item label="企业名称">
            <el-input
              type="textarea"
              autosize
              v-model="userForm.companyName"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="企业地址">
            <el-input
              type="textarea"
              autosize
              v-model="userForm.companyAddress"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人">
            <el-input
              type="textarea"
              autosize
              v-model="userForm.name"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input
              type="textarea"
              autosize
              v-model="userForm.username"
              :disabled="true"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="飞行器类型："
            v-if="this.dataId == 2 || this.dataId == 4"
          >
            <el-input
              type="textarea"
              autosize
              v-model="userForm.flight"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="作业范围："
            v-if="this.dataId == 2 || this.dataId == 4"
          >
            <el-input
              type="textarea"
              autosize
              v-model="userForm.range"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="测绘行业案例："
            v-if="this.dataId == 2 || this.dataId == 4"
          >
            <el-input
              type="textarea"
              autosize
              v-model="userForm.mappingCase"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="是否有固定空域："
            v-if="this.dataId == 2 || this.dataId == 4"
          >
            <el-input
              type="textarea"
              autosize
              v-model="userForm.airspace"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="固定空域："
            v-if="this.dataId == 2 || this.dataId == 4"
          >
            <el-input
              type="textarea"
              autosize
              v-model="userForm.airspaceDetails"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="可申请哪些区域空域："
            v-if="this.dataId == 2 || this.dataId == 4"
          >
            <el-input
              type="textarea"
              autosize
              v-model="userForm.applicableAirspace"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="传感器："
            v-if="this.dataId == 2 || this.dataId == 4"
          >
            <el-input
              type="textarea"
              autosize
              v-model="userForm.sensor"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="软件产品型号：" v-if="this.dataId == 3">
            <el-input
              type="textarea"
              autosize
              v-model="userForm.software"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="电子邮箱："
            v-if="this.dataId == 2 || this.dataId == 3 || this.dataId == 4"
          >
            <el-input
              type="textarea"
              autosize
              v-model="userForm.Email"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="shangchuan">
        <div style=" margin-bottom: 10px;">
          <i class="shenfen">法人身份证扫描件：</i>
        </div>

        <div>
          <img class="zhengmian" :src="positiveUrl" alt="" />
          <img class="fanmian" :src="backUrl" alt="" />
        </div>
        <div style=" margin-bottom: 10px;">
          <i class="yingye">营业执照扫描件：</i>
        </div>
        <div>
          <img class="yinyezhizhao" :src="licenseUrl" alt="" />
        </div>

        <div class="cehui" v-if="this.dataId == 2 || this.dataId == 4">
          <i>测绘资质证书扫描件：</i>
          <img
            v-for="(i, k) in mappingUrl"
            :key="k"
            class="saomianjian"
            style="margin-right: 20px;"
            :src="i"
            alt=""
          />
        </div>

        <div class="cehui" v-if="this.dataId == 2">
          <i>无人机证书扫描件：</i>
          <img
            v-for="(i, k) in Airworthy"
            :key="k"
            class="saomianjian"
            style="margin-right: 20px;"
            :src="i"
            alt=""
          />
        </div>
        <div class="cehui" v-if="this.dataId == 4">
          <i>适航证扫描件：</i>
          <img
            v-for="(i, k) in Airworthy"
            :key="k"
            class="saomianjian"
            style="margin-right: 20px;"
            :src="i"
            alt=""
          />
        </div>
      </div>

      <div class="anniu">
        <el-button type="primary" @click="submission()">撤销认证</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userForm: {
        companyName: "",
        companyAddress: "",
        name: "",
        username: "",

        flight: "",
        range: "",
        software: "",
        Email: "",
        cehuianli: "",
        kongyu: "",
        keshengqingkongyu: "",
        chuanganqi: "",
        kongyuxingxi: ""
      },
      //检验规则
      userRules: {},
      Airworthy: [],

      mappingUrl: [],

      licenseUrl: require("../../assets/img/zhengjian.png"),
      backUrl: require("../../assets/img/shenfenzbei.png"),
      positiveUrl: require("../../assets/img/shenfenzqian.png"),
      dataId: "",
      revoke: {
        function: "t_auth",
        ids: ""
      },
      testData: {}
    };
  },
  created() {
    this.sessionData();
    this.dataId = this.$route.query.dataId;
  },
  methods: {
    //获取session中数据
    async sessionData() {
      let config = {
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
      };
      const { data: dt } = await this.$http.post(
        "user/getUserInfo",
        "",
        config
      );

      this.testData = dt.data;

      this.userForm.companyName = this.testData.companyName;
      if (this.testData.hasOwnProperty("data")) {
        this.testData.data = JSON.parse(this.testData.data);
        this.userForm.companyAddress = this.testData.data.companyAddress;
        this.userForm.name = this.testData.data.name;
        this.userForm.username = this.testData.data.contacts;
        this.userForm.Email = this.testData.data.Email;
        this.userForm.software = this.testData.data.software;

        this.positiveUrl =
          this.$http.defaults.baseURL +
          "file" +
          "/" +
          this.testData.data.positiveUrl;
        this.backUrl =
          this.$http.defaults.baseURL +
          "file" +
          "/" +
          this.testData.data.backUrl;
        this.licenseUrl =
          this.$http.defaults.baseURL +
          "file" +
          "/" +
          this.testData.data.licenseUrl;
        if (this.testData.data.hasOwnProperty("manned") && this.dataId == 4) {
          this.testData.data.manned = JSON.parse(this.testData.data.manned);

          this.userForm.flight = this.testData.data.manned.flight;
          this.userForm.range = this.testData.data.manned.range;
          this.userForm.Email = this.testData.data.manned.Email;
          this.userForm.mappingCase = this.testData.data.manned.mappingCase;
          this.userForm.airspace = this.testData.data.manned.airspace;
          this.userForm.applicableAirspace = this.testData.data.manned.applicableAirspace;
          this.userForm.sensor = this.testData.data.manned.sensor;

          this.userForm.flight = this.testData.data.manned.flight;
          this.userForm.airspaceDetails = this.testData.data.manned.airspaceDetails;
          let mannedMappingUrl = this.testData.data.manned.mannedMappingUrl.split(
            ","
          );
          mannedMappingUrl.forEach(e => {
            let urlobj = this.$http.defaults.baseURL + "file" + "/" + e;

            this.mappingUrl.push(urlobj);
          });
          let mannedUrl = this.testData.data.manned.mannedUrl.split(",");
          mannedUrl.forEach(e => {
            let urlobj = this.$http.defaults.baseURL + "file" + "/" + e;

            this.Airworthy.push(urlobj);
          });
        }
        if (this.testData.data.hasOwnProperty("UAV") && this.dataId == 2) {
          this.testData.data.UAV = JSON.parse(this.testData.data.UAV);

          this.userForm.flight = this.testData.data.UAV.flight;
          this.userForm.range = this.testData.data.UAV.range;
          this.userForm.Email = this.testData.data.UAV.Email;
          this.userForm.mappingCase = this.testData.data.UAV.mappingCase;
          this.userForm.airspace = this.testData.data.UAV.airspace;
          this.userForm.sensor = this.testData.data.UAV.sensor;
          this.userForm.applicableAirspace = this.testData.data.UAV.applicableAirspace;
          this.userForm.flight = this.testData.data.UAV.flight;
          this.userForm.airspaceDetails = this.testData.data.UAV.airspaceDetails;
          let uavMappingUrl = this.testData.data.UAV.uavMappingUrl.split(",");
          uavMappingUrl.forEach(e => {
            let urlobj = this.$http.defaults.baseURL + "file" + "/" + e;

            this.mappingUrl.push(urlobj);
          });
          let uavUrl = this.testData.data.UAV.uavUrl.split(",");
          uavUrl.forEach(e => {
            let urlobj = this.$http.defaults.baseURL + "file" + "/" + e;

            this.Airworthy.push(urlobj);
          });
        }
        // console.log(this.testData.data.yourenji);
      }

      let auth = this.testData.auth;
      auth.forEach(e => {
        if (e.type == 2) {
          this.revoke.ids = e.id;
        }
        if (e.type == 1) {
          this.revoke.ids = e.id;
        }
        if (e.type == 3) {
          this.revoke.ids = e.id;
        }
        if (e.type == 4) {
          this.revoke.ids = e.id;
        }
      });
    },
    async submission() {
      const { data: dt } = await this.$http.post("general/delete", this.revoke);

      if (dt.status !== 200) {
        return this.$message.error(dt.msg);
      }
      // if (this.testData.data.hasOwnProperty("wurenjizhengshu3")){

      // }
      this.$message({
        message: "撤销成功",
        type: "success"
      });
      if (this.dataId == 1) {
        this.$router.push("/registered");
      } else {
        this.$router.push("/users");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.yinyezhizhao {
  width: 250px;
  height: 134px;
}
.saomianjian {
  display: inline-block;
  width: 250px;
  height: 134px;
  // overflow: hidden;
}
i {
  font-style: normal;
}

.el-card {
  // width: 100%;
  // height: 100%;
  // overflow: auto;
  position: relative;

  margin-bottom: 30px;
  // .content {
  //   display: flex;
  //   justify-content: flex-end;
  // }
  .xingxi {
    // width: 200px;
    // position: absolute;
    // left: 50px;
    // top: 60px;
    margin-left: 0px;
    margin-top: 20px;
    .tiao {
      width: 4px;
      height: 15px;
      background: rgba(0, 134, 253, 1);
      display: inline-block;
      margin-right: 10px;
    }
    i {
      // width: 65px;
      font-weight: bold;
      font-size: 16px;
    }
  }
  .biaodan {
    margin-top: 40px;
    // padding-left: 80px;
    // margin-right: 100px;
    // box-sizing: border-box;
    // width: 327px;
    // height: 342px;
    // position: absolute;
    // top: 150px;
    // left: 80px;
    // width: 320px;
    // .el-input {
    //   width: 320px;
    // }
  }
  .shangchuan {
    margin-bottom: 40px;
    margin-top: 40px;
    // width: 600px;
    // height: 400px;
    // position: absolute;
    // top: 150px;
    // left: 700px;

    // .shenfen {
    //   // position: absolute;
    //   // left: 0;
    //   // top: 0;
    // }
    // .yingye {
    //   // position: absolute;
    //   // top: 180px;
    //   // left: 0;
    // }
    .cehui {
      margin-top: 20px;
      overflow: hidden;
      i {
        display: block;
        margin-bottom: 10px;
      }
    }
    .zhengmian {
      width: 250px;
      height: 134px;
      display: inline-block;
      // margin-top: 30px;
      // margin-bottom: 40px;
      margin-right: 20px;
    }
    .fanmian {
      width: 250px;
      height: 134px;
      // margin-bottom: 40px;

      display: inline-block;
    }
  }
}

.anniu {
  // width: 100%;
  text-align: center;
  .el-button {
    width: 260px;
    height: 50px;
    // position: absolute;
    // left: 50%;
    // top: 830px;
    // transform: translateX(-50%);
  }
}
</style>
